/**
 * Canonical provisioning-setup entry navigation helpers.
 * Path cognitoryId is an untrusted selection request; backend access remains authoritative.
 */

import { isValidCognitoryWorkspaceId } from "./cognitoryWorkspaceNavigation";

export const COGNITORY_PROVISIONING_SETUP_PATH_PREFIX =
  "/provisioning-setup" as const;

export function buildCanonicalProvisioningSetupPath(
  cognitoryId: string,
): string {
  if (!isValidCognitoryWorkspaceId(cognitoryId)) {
    throw new Error("invalid cognitory provisioning-setup id");
  }
  return `${COGNITORY_PROVISIONING_SETUP_PATH_PREFIX}/${encodeURIComponent(cognitoryId)}`;
}

export function parseProvisioningSetupRouteCognitoryId(
  routeParam: string | undefined,
): string | null {
  if (!routeParam || !isValidCognitoryWorkspaceId(routeParam)) {
    return null;
  }
  return routeParam;
}
